import { EventEmitter, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NbAvatarService {
  public changeStream: any = new Subject<any>();
}
